import * as React from 'react';
import { FunctionComponent } from 'react';
import { SchoolEvent } from 'Src/models/event';
import './DetailsTab.css';
import { EventDetailsSummary } from 'Src/components/EventDetailsSummary/EventDetailsSummary';

interface Props {
  schoolEvent: SchoolEvent;
  eventsDetails: any;
}

export const StudentEventDetailsSummaryTab: FunctionComponent<Props> = props => {
  return <EventDetailsSummary event={props.schoolEvent} details={props.eventsDetails} />;
};

StudentEventDetailsSummaryTab.displayName = 'StudentEventDetailsSummaryTab';
